import { render, staticRenderFns } from "./batch-upload.vue?vue&type=template&id=16356874&scoped=true&"
import script from "./batch-upload.vue?vue&type=script&lang=js&"
export * from "./batch-upload.vue?vue&type=script&lang=js&"
import style0 from "./batch-upload.vue?vue&type=style&index=0&id=16356874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16356874",
  null
  
)

export default component.exports